import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { ManWithTablet } from '~/assets/illustrations'
import { useIsMobileScreen } from '~/hooks'

const useStyles = makeStyles({
  container: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    [mutualTheme.breakpoints.down('md')]: {
      width: 300,
      height: 300
    }
  },
  title: {
    display: 'flex',
    fontWeight: 'bold',
    marginBottom: mutualTheme.spacing(2),
    color: mutualTheme.palette.mutualBlue.main
  }
})

type AnalysisModalProps = {
  isOpen: boolean
}

export const AnalysisModal: React.FC<AnalysisModalProps> = ({ isOpen }) => {
  const [dots, setDots] = useState('')
  const classes = useStyles()
  const isMobile = useIsMobileScreen()

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        if (dots.length === 3) {
          setDots('')
          return
        }
        setDots(dots + '.')
      }, 1000)
    }
  }, [isOpen, dots])

  return (
    <Box className={classes.container}>
      {!isMobile && (
        <Box>
          <ManWithTablet />
        </Box>
      )}
      <Typography className={classes.title} variant='h3' align='center'>
        Analisando seus dados. Aguarde{dots}
      </Typography>
      <Typography variant='body1' align='center'>
        Recebemos sua solicitação e estamos analisando seus dados. Por favor, aguarde o processo de análise automática que pode levar alguns minutos.
      </Typography>
    </Box>
  )
}
